export default __webpack_public_path__ + "static/media/wishlist.b04e1363.svg";